// Utilitaires pour gérer les "préférences" client stockées dans le champ tags
// avec préfixes : "dom:" pour domaines artistiques, "art:" pour artistes favoris.
// Les autres tags (sans préfixe connu) restent intacts.

const DOM_PREFIX = 'dom:';
const ART_PREFIX = 'art:';

export function extractClientPrefs(tags: string[] | undefined | null) {
  const all = tags || [];
  return {
    domaines: all.filter((t) => t.startsWith(DOM_PREFIX)).map((t) => t.slice(DOM_PREFIX.length)),
    artistes: all.filter((t) => t.startsWith(ART_PREFIX)).map((t) => t.slice(ART_PREFIX.length)),
    others: all.filter((t) => !t.startsWith(DOM_PREFIX) && !t.startsWith(ART_PREFIX)),
  };
}

export function buildClientTags(others: string[], domaines: string[], artistes: string[]): string[] {
  return [
    ...others.filter(Boolean),
    ...domaines.filter(Boolean).map((d) => `${DOM_PREFIX}${d}`),
    ...artistes.filter(Boolean).map((a) => `${ART_PREFIX}${a}`),
  ];
}
